import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import './Language.css';

function Language() {
  const { i18n } = useTranslation();
  console.log(i18n.language);
  function changeLanguage(lng) {
    i18n.changeLanguage(lng);
  }
  return (
    <div className="language">
      <Button
        onClick={() => {
          changeLanguage('jp');
        }}
        active={i18n.language === 'jp'}
      >
        {' '}
        日本語{' '}
      </Button>
      <Button
        onClick={() => {
          changeLanguage('en');
        }}
        active={i18n.language === 'en'}
      >
        {' '}
        EN{' '}
      </Button>
    </div>
  );
}

export default Language;
